<template>
  <div>
     <el-dialog
      :visible.sync="showSendConfirm"
      title="发送确认"
      append-to-body
      width="450px"
      :before-close="handleClose"
      custom-class="send-con-dialog"
    >
      <div>
        <span>提交号码为 {{ phoneLenght }}</span>
        ，当前短信字数为
        <span :style="{ color: globalBG }">{{ sendInfoLength }}</span>
        字，每条短信以
        <span :style="{ color: globalBG }">{{
          Math.ceil(
            sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
          )
        }}</span>
        条计费，提交
        <span :style="{ color: globalBG }">{{
            phoneLenght *
              Math.ceil(
                sendInfoLength > 70 ? sendInfoLength / 67 : sendInfoLength / 70
              )
        }}</span>
        条短信，以实际发送条数为准！
      </div>
      <div class="btn-group">
        <el-button type="primary" v-loading="sendLoading" @click="handleSendConfirm">发送</el-button>
        <el-button @click="sendVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  preCommit,
  NewPreCommit,
  platformSend,
} from "@/api/smsSend";
export default {
  name: '',
  props: {
    formData: {
      type: Object,
      default: {}
    },
    TTip: {
      type: String,
      default: ''
    },
    showSendConfirm: {
      type: Boolean,
      default: false
    },
    phoneLenght: {
      type: Number,
      default: 0
    },
    sendInfoLength: {
      type: Number,
      default: 0,
    },
    mobiles: {
      type: String,
      default: ''
    },
    isCustom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sendObjectId: '',
      sendLoading: false,
    }
  },
  methods: {
    handleSendConfirm() {
      // 自定义
      if(this.isCustom){
        return this.$emit('comfirm')
      }
      var mobiles = this.mobiles.split(",");
      var param = {
        dataFrom: 0,
        sendType: 0,
        mobiles: mobiles,
      };
      this.sendLoading = true;
      // preCommit(param).then((res) => {
      let postData = {
        content: this.formData.content+'拒收请回复R',
        // jdSmsSuffix: this.formData.jdSmsSuffix,
        mobile: param.mobiles.join(','),
      }
      // 短信测试新接口
      NewPreCommit(postData).then((res) => {
        if (res.code == "1") {
          this.sendLoading = false;
          // this.sendObjectId = res.data.sendObjectId;
          // this.handleSendPlatform();
          this.handleClose();
          this.$message.success(res.data)
        } else{
          this.sendLoading = false;
          this.$message.error(res.message);
        }
      })
      // this.handleClose();
    },
    handleSendPlatform() {
      var param = {
        content: this.formData.content + this.TTip,
        sendObjectId: this.sendObjectId,
        smsSuffix: this.formData.jdSmsSuffix,
        blackFlag: false,
        smsType: 0
      }
      platformSend(param).then((res) => {
        this.sendLoading = false;
        if (res.code == '1') {
          this.$message.success("发送成功");
          this.handleClose();
        } else {
          this.$message.error(res.message);
        }
      })
    },
    handleClose() {
      this.sendVisible = false;
    }
  },
  computed: {
    sendVisible: {
     get: function() {
       return this.showSendConfirm
     },
     set: function(newValue) {
       if (newValue) {
         this.$emit('update:showSendConfirm', true)
       } else {
         this.$emit('update:showSendConfirm', false)
       }
     }
    },
    ...mapState({
      globalBG: "globalBG",
    })
  }
}
</script>

<style scoped lang="scss">
/* 发送确认弹窗 */
.send-con-dialog {
  .success-tip {
    text-align: center;
    font-size: 14px;
    color: #333;
    img {
      margin-right: 10px;
      vertical-align: middle;
    }
  }
  .btn-group {
    margin-top: 30px;
    text-align: center;
  }
}
</style>